<template>
  <div class="expert-form">
    <div class="base-info">
      <div style="width:250px;">项目编号：{{projectData.projectFull}}</div>
      <div style="width:250px;">流水号：{{wiid}}</div>
      <div style="width:100%;">项目名称：{{projectData.projectName}}</div>
      <div style="width:100%;">分子公司：{{projectData.companyName}}</div>
      <div style="width:250px;">项目采购预算：{{projectData.purchaseBudget}}</div>
      <div>包组数：{{projectData.groupCount}}</div>
      <div>招标平台：{{projectData.bidPlatform}}</div>
      <div style="width:250px;">预计评标时间：{{bidTime}}</div>
      <div>预计服务费收入：{{projectData.servicePredict}}</div>
      <div>实际服务费收入：{{projectData.receivables}}</div>
    </div>
    <Tabs type="card" style="margin-top:5px;" v-model="currentTab">
      <Button size="small" type="success" slot="extra" @click="printView">打印预览</Button>
      <TabPane label="专家费（申请）" name="apply">
        <Form
          inline
          :label-width="110"
        >
          <!-- <div style="text-align:center;margin:10px;font-weight:600;font-size:16px;">申请专家费</div> -->
          <table
            class="expert-form-table"
            cellspacing="0"
          >
            <tr>
              <td>
                <FormItem label="本地专家（人）">
                  <Input v-model.number="applyExpertForm.localExpert" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="专家支付标准（元/人）">
                  <Input v-model.number="applyExpertForm.localExpertFee" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="applyLocalExpertTotal" readonly :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="外地专家（人）">
                  <Input v-model.number="applyExpertForm.otherExpert" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="专家支付标准（元/人）">
                  <Input v-model.number="applyExpertForm.otherExpertFee" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="applyOtherExpertTotal" readonly :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="监督（人）">
                  <Input v-model.number="applyExpertForm.supervise" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="监督支付标准（元/人）">
                  <Input v-model.number="applyExpertForm.superviseFee" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="applySuperviseTotal" readonly :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="采购人代表（人）">
                  <Input v-model.number="applyExpertForm.buyer" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="采购人支付标准（元/人）">
                  <Input v-model.number="applyExpertForm.buyerFee" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="applyBuyerTotal" readonly :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="交通费（人）">
                  <Input v-model.number="applyExpertForm.traffic" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="交通费支付标准（元/人）">
                  <Input v-model.number="applyExpertForm.trafficFee" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="applyTrafficTotal" readonly :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <FormItem label="其他（元）">
                  <Input v-model.number="applyExpertForm.otherFee" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="applyTotal" readonly :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <!-- <tr>
              <td colspan="2">
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input></Input>
                </FormItem>
              </td>
            </tr> -->
            <tr>
              <td colspan="2">
                <FormItem label="备注">
                  <Input v-model="applyExpertForm.remark" :title="applyExpertForm.remark" style="width:400px" :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
              <td colspan="1">
                <FormItem label="预计费用率（%）">
                  <Input v-model="applyCostRate" readonly :disabled="applyDisabled"></Input>
                </FormItem>
              </td>
            </tr>
          </table>
        </Form>
      </TabPane>
      <TabPane label="专家费（实际-可核销）" name="realityY">
        <Form
          inline
          :label-width="110"
        >
          <!-- <div style="text-align:center;margin:10px;font-weight:600;font-size:16px;">申请专家费</div> -->
          <table
            class="expert-form-table"
            cellspacing="0"
          >
            <tr>
              <td>
                <FormItem label="本地专家（人）">
                  <Input v-model.number="realityExpertFormY.localExpert" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="专家支付标准（元/人）">
                  <Input v-model.number="realityExpertFormY.localExpertFee" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityYLocalExpertTotal" readonly :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="外地专家（人）">
                  <Input v-model.number="realityExpertFormY.otherExpert" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="专家支付标准（元/人）">
                  <Input v-model.number="realityExpertFormY.otherExpertFee" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityYOtherExpertTotal" readonly :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="监督（人）">
                  <Input v-model.number="realityExpertFormY.supervise" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="监督支付标准（元/人）">
                  <Input v-model.number="realityExpertFormY.superviseFee" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityYSuperviseTotal" readonly :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="采购人代表（人）">
                  <Input v-model.number="realityExpertFormY.buyer" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="采购人支付标准（元/人）">
                  <Input v-model.number="realityExpertFormY.buyerFee" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityYBuyerTotal" readonly :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="交通费（人）">
                  <Input v-model.number="realityExpertFormY.traffic" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="交通费支付标准（元/人）">
                  <Input v-model.number="realityExpertFormY.trafficFee" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityYTrafficTotal" readonly :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <FormItem label="其他（元）">
                  <Input v-model.number="realityExpertFormY.otherFee" :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityYTotal" readonly :disabled="realityYDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <FormItem label="回收证明文件" required>
                  <Input v-model="file.fileName" readonly style="width:200px;" :disabled="realityYDisabled"></Input>
                  <span>（只允许png,jpg,jpeg,pdf格式）</span>
                </FormItem>
              </td>
              <td>
                <Upload style="display:inline-block" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
                  <Button size="small" type="primary" style="margin: 0 20px 0 40px;" :disabled="realityYDisabled">上传</Button>
                </Upload>
                <Button size="small" type="success" @click="downloadFile">下载</Button>
              </td>
            </tr>
            <!-- <tr>
              <td colspan="2">
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input></Input>
                </FormItem>
              </td>
            </tr> -->
            <!-- <tr>
              <td colspan="2">
                <FormItem label="备注">
                  <Input style="width:400px"></Input>
                </FormItem>
              </td>
              <td colspan="1">
                <FormItem label="预计费用率（%）">
                  <Input v-model="applyCostRate"></Input>
                </FormItem>
              </td>
            </tr> -->
          </table>
        </Form>
      </TabPane>
      <TabPane label="专家费（实际-不可核销）" name="realityN">
        <Form
          inline
          :label-width="110"
        >
          <!-- <div style="text-align:center;margin:10px;font-weight:600;font-size:16px;">申请专家费</div> -->
          <table
            class="expert-form-table"
            cellspacing="0"
          >
            <tr>
              <td>
                <FormItem label="本地专家（人）">
                  <Input v-model.number="realityExpertFormN.localExpert" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="专家支付标准（元/人）">
                  <Input v-model.number="realityExpertFormN.localExpertFee" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityNLocalExpertTotal" readonly :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="外地专家（人）">
                  <Input v-model.number="realityExpertFormN.otherExpert" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="专家支付标准（元/人）">
                  <Input v-model.number="realityExpertFormN.otherExpertFee" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityNOtherExpertTotal" readonly :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="监督（人）">
                  <Input v-model.number="realityExpertFormN.supervise" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="监督支付标准（元/人）">
                  <Input v-model.number="realityExpertFormN.superviseFee" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityNSuperviseTotal" readonly :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="采购人代表（人）">
                  <Input v-model.number="realityExpertFormN.buyer" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="采购人支付标准（元/人）">
                  <Input v-model.number="realityExpertFormN.buyerFee" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityNBuyerTotal" readonly :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem label="交通费（人）">
                  <Input v-model.number="realityExpertFormN.traffic" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="交通费支付标准（元/人）">
                  <Input v-model.number="realityExpertFormN.trafficFee" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityNTrafficTotal" readonly :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <FormItem label="其他（元）">
                  <Input v-model.number="realityExpertFormN.otherFee" :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input v-model="realityNTotal" readonly :disabled="realityNDisabled"></Input>
                </FormItem>
              </td>
            </tr>
            <!-- <tr>
              <td colspan="2">
              </td>
              <td>
                <FormItem label="合计（元）">
                  <Input></Input>
                </FormItem>
              </td>
            </tr> -->
            <!-- <tr>
              <td colspan="2">
                <FormItem label="备注">
                  <Input style="width:400px"></Input>
                </FormItem>
              </td>
              <td colspan="1">
                <FormItem label="预计费用率（%）">
                  <Input v-model="applyCostRate"></Input>
                </FormItem>
              </td>
            </tr> -->
          </table>
        </Form>
      </TabPane>
    </Tabs>
    <Form inline :label-width="120" style="margin-top:10px;">
      <table
        class="expert-form-table"
        cellspacing="0"
      >
        <tr>
          <td>
            <FormItem label="实际费用率">
              <Input v-model="realityRate" readonly :disabled="extraDisabled"></Input>
            </FormItem>
          </td>
          <td>
            <FormItem label="可核销占比（%）">
              <Input v-model="reimburseYRate" readonly :disabled="extraDisabled"></Input>
            </FormItem>
          </td>
          <td>
            <FormItem label="不可核销占比（%）">
              <Input v-model="reimburseNRate" readonly :disabled="extraDisabled"></Input>
            </FormItem>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <FormItem label="非标准费用支出说明" :label-width="150">
              <Input v-model="extraForm.nonstandardFee" style="width:500px" :disabled="extraDisabled"></Input>
            </FormItem>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <FormItem label="非标准人员支出说明" :label-width="150">
              <Input v-model="extraForm.nonstandardPerson" style="width:500px" :disabled="extraDisabled"></Input>
            </FormItem>
          </td>
        </tr>
        <tr>
          <td colspan="1">
            <FormItem label="实际评标时间（小时）" :label-width="150" required>
              <Input v-model.number="extraForm.realityBiddingTime" style="width:100px" :disabled="extraDisabled"></Input>
            </FormItem>
          </td>
          <td colspan="2">
            <FormItem label="其他说明" :label-width="120">
              <Input v-model="extraForm.otherRemark" style="width:350px" :disabled="extraDisabled" :title="extraForm.otherRemark"></Input>
            </FormItem>
          </td>
        </tr>
        <tr>
          <td>
            <FormItem label="实际回收金额">
              <Input v-model="realityFeeBack" readonly :disabled="extraDisabled"></Input>
            </FormItem>
          </td>
          <td>
            <FormItem label="采购失败">
              <RadioGroup v-model="extraForm.purchaseSuccess">
                <Radio label="是" :disabled="extraDisabled"></Radio>
                <Radio label="否" :disabled="extraDisabled"></Radio>
              </RadioGroup>
            </FormItem>
          </td>
          <td>
            <FormItem label="失败时间">
              <RadioGroup v-model="extraForm.failTime">
                <Radio label="标前" :disabled="extraDisabled"></Radio>
                <Radio label="标后" :disabled="extraDisabled"></Radio>
              </RadioGroup>
            </FormItem>
          </td>
        </tr>
      </table>
    </Form>
    <!-- <Modal v-model="expertFeePrintVisible" :title="printTitle" :transfer="false" width="800px;" class-name="print-modal">
      <div class="split-page" v-show="printPage">
        <div class="base-info">
          <div style="width:250px;">项目编号：{{projectData.projectFull}}</div>
          <div style="width:250px;">流水号：{{wiid}}</div>
          <div style="width:100%;">项目名称：{{projectData.projectName}}</div>
          <div style="width:250px;">项目采购预算：{{projectData.purchaseBudget}}</div>
          <div>包组数：{{projectData.groupCount}}</div>
          <div>招标平台：{{projectData.bidPlatform}}</div>
          <div style="width:250px;">预计评标时间：{{bidTime}}</div>
          <div>预计服务费收入：{{projectData.servicePredict}}</div>
          <div>实际服务费收入：{{projectData.receivables}}</div>
        </div>
        <div>
          <div style="padding:5px;">专家费（申请）</div>
          <table class="expert-form-table extra-table-style" cellspacing="0" style="width:100%">
            <tr>
              <td>本地专家（人）:{{applyExpertForm.localExpert}}</td>
              <td>专家支付标准（元/人）:{{applyExpertForm.localExpertFee}}</td>
              <td>合计（元）:{{applyLocalExpertTotal}}</td>
            </tr>
            <tr>
              <td>外地专家（人）:{{applyExpertForm.otherExpert}}</td>
              <td>专家支付标准（元/人）:{{applyExpertForm.otherExpertFee}}</td>
              <td>合计（元）:{{applyOtherExpertTotal}}</td>
            </tr>
            <tr>
              <td>监督（人）:{{applyExpertForm.supervise}}</td>
              <td>监督支付标准（元/人）:{{applyExpertForm.superviseFee}}</td>
              <td>合计（元）:{{applySuperviseTotal}}</td>
            </tr>
            <tr>
              <td>采购人代表（人）:{{applyExpertForm.buyer}}</td>
              <td>采购人支付标准（元/人）:{{applyExpertForm.buyerFee}}</td>
              <td>合计（元）:{{applyBuyerTotal}}</td>
            </tr>
            <tr>
              <td>交通费（人）:{{applyExpertForm.traffic}}</td>
              <td>交通费支付标准（元/人）:{{applyExpertForm.trafficFee}}</td>
              <td>合计（元）:{{applyTrafficTotal}}</td>
            </tr>
            <tr>
              <td colspan="2">其他（元）:{{applyExpertForm.otherFee}}</td>
              <td>合计（元）:{{applyTotal}}</td>
            </tr>
            <tr>
              <td colspan="2">备注:{{applyExpertForm.remark}}</td>
              <td>预计费用率（%）:{{applyCostRate}}</td>
            </tr>
          </table>
          <div style="padding:5px;">专家费（实际-可核销）</div>
          <table class="expert-form-table extra-table-style" cellspacing="0" style="width:100%">
            <tr>
              <td>本地专家（人）:{{realityExpertFormY.localExpert}}</td>
              <td>专家支付标准（元/人）:{{realityExpertFormY.localExpertFee}}</td>
              <td>合计（元）:{{realityYLocalExpertTotal}}</td>
            </tr>
            <tr>
              <td>外地专家（人）:{{realityExpertFormY.otherExpert}}</td>
              <td>专家支付标准（元/人）:{{realityExpertFormY.otherExpertFee}}</td>
              <td>合计（元）:{{realityYOtherExpertTotal}}</td>
            </tr>
            <tr>
              <td>监督（人）:{{realityExpertFormY.supervise}}</td>
              <td>监督支付标准（元/人）:{{realityExpertFormY.superviseFee}}</td>
              <td>合计（元）:{{realityYSuperviseTotal}}</td>
            </tr>
            <tr>
              <td>采购人代表（人）:{{realityExpertFormY.buyer}}</td>
              <td>采购人支付标准（元/人）:{{realityExpertFormY.buyerFee}}</td>
              <td>合计（元）:{{realityYBuyerTotal}}</td>
            </tr>
            <tr>
              <td>交通费（人）:{{realityExpertFormY.traffic}}</td>
              <td>交通费支付标准（元/人）:{{realityExpertFormY.trafficFee}}</td>
              <td>合计（元）:{{realityYTrafficTotal}}</td>
            </tr>
            <tr>
              <td colspan="2">其他（元）:{{realityExpertFormY.otherFee}}</td>
              <td>合计（元）:{{realityYTotal}}</td>
            </tr>
          </table>
          <div style="padding:5px;">专家费（实际-不可核销）</div>
          <table class="expert-form-table extra-table-style" cellspacing="0" style="width:100%">
            <tr>
              <td>本地专家（人）:{{realityExpertFormN.localExpert}}</td>
              <td>专家支付标准（元/人）:{{realityExpertFormN.localExpertFee}}</td>
              <td>合计（元）:{{realityNLocalExpertTotal}}</td>
            </tr>
            <tr>
              <td>外地专家（人）:{{realityExpertFormN.otherExpert}}</td>
              <td>专家支付标准（元/人）:{{realityExpertFormN.otherExpertFee}}</td>
              <td>合计（元）:{{realityNOtherExpertTotal}}</td>
            </tr>
            <tr>
              <td>监督（人）:{{realityExpertFormN.supervise}}</td>
              <td>监督支付标准（元/人）:{{realityExpertFormN.superviseFee}}</td>
              <td>合计（元）:{{realityNSuperviseTotal}}</td>
            </tr>
            <tr>
              <td>采购人代表（人）:{{realityExpertFormN.buyer}}</td>
              <td>采购人支付标准（元/人）:{{realityExpertFormN.buyerFee}}</td>
              <td>合计（元）:{{realityNBuyerTotal}}</td>
            </tr>
            <tr>
              <td>交通费（人）:{{realityExpertFormN.traffic}}</td>
              <td>交通费支付标准（元/人）:{{realityExpertFormN.trafficFee}}</td>
              <td>合计（元）:{{realityNTrafficTotal}}</td>
            </tr>
            <tr>
              <td colspan="2">其他（元）:{{realityExpertFormN.otherFee}}</td>
              <td>合计（元）:{{realityNTotal}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="split-page" v-show="!printPage">
        <div style="padding:5px;">汇总信息</div>
        <table class="expert-form-table extra-table-style" cellspacing="0" style="width:100%">
          <tr>
            <td>实际费用率:{{realityRate}}</td>
            <td>可核销占比（%）:{{reimburseYRate}}</td>
            <td>不可核销占比（%）:{{reimburseNRate}}</td>
          </tr>
          <tr>
            <td colspan="3">非标准费用支出说明:{{extraForm.nonstandardFee}}</td>
          </tr>
          <tr>
            <td colspan="3">非标准人员支出说明:{{extraForm.nonstandardPerson}}</td>
          </tr>
          <tr>
            <td colspan="1">实际评标时间（小时）:{{extraForm.realityBiddingTime}}</td>
            <td colspan="2">其他说明:{{extraForm.otherRemark}}</td>
          </tr>
          <tr>
            <td>实际回收金额:{{realityFeeBack}}</td>
            <td>采购失败:{{extraForm.purchaseSuccess}}</td>
            <td>失败时间:{{extraForm.failTime}}</td>
          </tr>
        </table>
        <div style="padding:5px;">流程信息</div>
        <table cellspacing="0" class="expert-form-table extra-table-style" style="width:100%;text-align:center;">
          <tr>
            <th style="width:150px;">操作类型</th>
            <th style="width: 150px;">操作人</th>
            <th style="width:80px;">执行结果</th>
            <th style="width:150px;">操作时间</th>
            <th>备注</th>
          </tr>
          <tr v-for="flow in flowHistoryData">
            <td>{{flow.ActivityShowName}}</td>
            <td>{{flow.RealName}}</td>
            <td>{{flow.CompletedType | filterHistoryStatus}}</td>
            <td>{{flow.CompletedTime | filterFlowTime}}</td>
            <td>{{flow.Opinion}}</td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="print-btn">
        <Button @click="expertFeePrintVisible=false">取消</Button>
        <Button type="primary" @click="printPage = !printPage">{{printPage ? '下一页' : '上一页'}}</Button>
        <Button type="success" @click="print">打印</Button>
      </div>
    </Modal> -->
    <div id="expert-print" style="display:none">
      <div class="split-page">
        <div class="base-info">
          <div style="width:250px;">项目编号：{{projectData.projectFull}}</div>
          <div style="width:250px;">流水号：{{wiid}}</div>
          <div style="width:100%;">项目名称：{{projectData.projectName}}</div>
          <div style="width:100%;">分子公司：{{projectData.companyName}}</div>
          <div style="width:250px;">项目采购预算：{{projectData.purchaseBudget}}</div>
          <div>包组数：{{projectData.groupCount}}</div>
          <div>招标平台：{{projectData.bidPlatform}}</div>
          <div style="width:250px;">预计评标时间：{{bidTime}}</div>
          <div>预计服务费收入：{{projectData.servicePredict}}</div>
          <div>实际服务费收入：{{projectData.receivables}}</div>
        </div>
        <div>
          <div style="padding:5px;">专家费（申请）</div>
          <table class="expert-form-table extra-table-style" cellspacing="0" style="width:100%">
            <tr>
              <td>本地专家（人）:{{applyExpertForm.localExpert}}</td>
              <td>专家支付标准（元/人）:{{applyExpertForm.localExpertFee}}</td>
              <td>合计（元）:{{applyLocalExpertTotal}}</td>
            </tr>
            <tr>
              <td>外地专家（人）:{{applyExpertForm.otherExpert}}</td>
              <td>专家支付标准（元/人）:{{applyExpertForm.otherExpertFee}}</td>
              <td>合计（元）:{{applyOtherExpertTotal}}</td>
            </tr>
            <tr>
              <td>监督（人）:{{applyExpertForm.supervise}}</td>
              <td>监督支付标准（元/人）:{{applyExpertForm.superviseFee}}</td>
              <td>合计（元）:{{applySuperviseTotal}}</td>
            </tr>
            <tr>
              <td>采购人代表（人）:{{applyExpertForm.buyer}}</td>
              <td>采购人支付标准（元/人）:{{applyExpertForm.buyerFee}}</td>
              <td>合计（元）:{{applyBuyerTotal}}</td>
            </tr>
            <tr>
              <td>交通费（人）:{{applyExpertForm.traffic}}</td>
              <td>交通费支付标准（元/人）:{{applyExpertForm.trafficFee}}</td>
              <td>合计（元）:{{applyTrafficTotal}}</td>
            </tr>
            <tr>
              <td colspan="2">其他（元）:{{applyExpertForm.otherFee}}</td>
              <td>合计（元）:{{applyTotal}}</td>
            </tr>
            <tr>
              <td colspan="2">备注:{{applyExpertForm.remark}}</td>
              <td>预计费用率（%）:{{applyCostRate}}</td>
            </tr>
          </table>
          <div style="padding:5px;">专家费（实际-可核销）</div>
          <table class="expert-form-table extra-table-style" cellspacing="0" style="width:100%">
            <tr>
              <td>本地专家（人）:{{realityExpertFormY.localExpert}}</td>
              <td>专家支付标准（元/人）:{{realityExpertFormY.localExpertFee}}</td>
              <td>合计（元）:{{realityYLocalExpertTotal}}</td>
            </tr>
            <tr>
              <td>外地专家（人）:{{realityExpertFormY.otherExpert}}</td>
              <td>专家支付标准（元/人）:{{realityExpertFormY.otherExpertFee}}</td>
              <td>合计（元）:{{realityYOtherExpertTotal}}</td>
            </tr>
            <tr>
              <td>监督（人）:{{realityExpertFormY.supervise}}</td>
              <td>监督支付标准（元/人）:{{realityExpertFormY.superviseFee}}</td>
              <td>合计（元）:{{realityYSuperviseTotal}}</td>
            </tr>
            <tr>
              <td>采购人代表（人）:{{realityExpertFormY.buyer}}</td>
              <td>采购人支付标准（元/人）:{{realityExpertFormY.buyerFee}}</td>
              <td>合计（元）:{{realityYBuyerTotal}}</td>
            </tr>
            <tr>
              <td>交通费（人）:{{realityExpertFormY.traffic}}</td>
              <td>交通费支付标准（元/人）:{{realityExpertFormY.trafficFee}}</td>
              <td>合计（元）:{{realityYTrafficTotal}}</td>
            </tr>
            <tr>
              <td colspan="2">其他（元）:{{realityExpertFormY.otherFee}}</td>
              <td>合计（元）:{{realityYTotal}}</td>
            </tr>
          </table>
          <div style="padding:5px;">专家费（实际-不可核销）</div>
          <table class="expert-form-table extra-table-style" cellspacing="0" style="width:100%">
            <tr>
              <td>本地专家（人）:{{realityExpertFormN.localExpert}}</td>
              <td>专家支付标准（元/人）:{{realityExpertFormN.localExpertFee}}</td>
              <td>合计（元）:{{realityNLocalExpertTotal}}</td>
            </tr>
            <tr>
              <td>外地专家（人）:{{realityExpertFormN.otherExpert}}</td>
              <td>专家支付标准（元/人）:{{realityExpertFormN.otherExpertFee}}</td>
              <td>合计（元）:{{realityNOtherExpertTotal}}</td>
            </tr>
            <tr>
              <td>监督（人）:{{realityExpertFormN.supervise}}</td>
              <td>监督支付标准（元/人）:{{realityExpertFormN.superviseFee}}</td>
              <td>合计（元）:{{realityNSuperviseTotal}}</td>
            </tr>
            <tr>
              <td>采购人代表（人）:{{realityExpertFormN.buyer}}</td>
              <td>采购人支付标准（元/人）:{{realityExpertFormN.buyerFee}}</td>
              <td>合计（元）:{{realityNBuyerTotal}}</td>
            </tr>
            <tr>
              <td>交通费（人）:{{realityExpertFormN.traffic}}</td>
              <td>交通费支付标准（元/人）:{{realityExpertFormN.trafficFee}}</td>
              <td>合计（元）:{{realityNTrafficTotal}}</td>
            </tr>
            <tr>
              <td colspan="2">其他（元）:{{realityExpertFormN.otherFee}}</td>
              <td>合计（元）:{{realityNTotal}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="split-page">
        <div style="padding:5px;">汇总信息</div>
        <table class="expert-form-table extra-table-style" cellspacing="0" style="width:100%">
          <tr>
            <td>实际费用率:{{realityRate}}</td>
            <td>可核销占比（%）:{{reimburseYRate}}</td>
            <td>不可核销占比（%）:{{reimburseNRate}}</td>
          </tr>
          <tr>
            <td colspan="3">非标准费用支出说明:{{extraForm.nonstandardFee}}</td>
          </tr>
          <tr>
            <td colspan="3">非标准人员支出说明:{{extraForm.nonstandardPerson}}</td>
          </tr>
          <tr>
            <td colspan="1">实际评标时间（小时）:{{extraForm.realityBiddingTime}}</td>
            <td colspan="2">其他说明:{{extraForm.otherRemark}}</td>
          </tr>
          <tr>
            <td>实际回收金额:{{realityFeeBack}}</td>
            <td>采购失败:{{extraForm.purchaseSuccess}}</td>
            <td>失败时间:{{extraForm.failTime}}</td>
          </tr>
        </table>
        <div style="padding:5px;">流程信息</div>
        <table cellspacing="0" class="expert-form-table extra-table-style" style="width:100%;text-align:center;">
          <tr>
            <th style="width:150px;">操作类型</th>
            <th style="width: 150px;">操作人</th>
            <th style="width:80px;">执行结果</th>
            <th style="width:150px;">操作时间</th>
            <th>备注</th>
          </tr>
          <!-- <tr v-for="flow in flowHistoryData">
            <td>{{flow.ActivityShowName}}</td>
            <td>{{flow.RealName}}</td>
            <td>{{flow.CompletedType | filterHistoryStatus}}</td>
            <td>{{flow.CompletedTime | filterFlowTime}}</td>
            <td>{{flow.Opinion}}</td>
          </tr> -->
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import x2js from "x2js"
import { fileUtil } from '@/lib/abpfile'
import axios from 'axios'
import { formatDate, add, subduction } from '@/lib/tool'

export default {
  name: 'expertFeeForm',
  props: {
    projectData: {
      type: Object
    },
    uploadFileInit: {
      type: Object,
      default() {
        return {
          extradata: {},
          action: ''
        }
      }
    },
    flowHistoryData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      printPage: true,
      currentTab: 'apply',
      applyExpertForm: {
        localExpert: 0, //本地专家
        localExpertFee: 0, // 专家支付标准
        // localExpertTotal: 0,
        otherExpert: 0, // 外地专家
        otherExpertFee: 0, // 专家支付标准
        // otherExpertTotal: 0,
        supervise: 0, // 监督
        superviseFee: 0, // 监督支付标准
        // superviseTotal: 0,
        buyer: 0, // 采购人代表
        buyerFee: 0, //采购人支付标准
        // buyerTotal: 0,
        traffic: 0, // 交通费
        trafficFee: 0, // 交通费支付标准
        // trafficTotal: 0,
        otherFee: 0, // 其他
        remark: '', // 备注
        // total: 0,
        // costRate: 0
      },
      realityExpertFormY: {
        localExpert: 0,
        localExpertFee: 0,
        // localExpertTotal: 0,
        otherExpert: 0,
        otherExpertFee: 0,
        // otherExpertTotal: 0,
        supervise: 0,
        superviseFee: 0,
        // superviseTotal: 0,
        buyer: 0,
        buyerFee: 0,
        // buyerTotal: 0,
        traffic: 0,
        trafficFee: 0,
        // trafficTotal: 0,
        otherFee: 0,
        // total: 0,
      },
      realityExpertFormN: {
        localExpert: 0,
        localExpertFee: 0,
        // localExpertTotal: 0,
        otherExpert: 0,
        otherExpertFee: 0,
        // otherExpertTotal: 0,
        supervise: 0,
        superviseFee: 0,
        // superviseTotal: 0,
        buyer: 0,
        buyerFee: 0,
        // buyerTotal: 0,
        traffic: 0,
        trafficFee: 0,
        // trafficTotal: 0,
        otherFee: 0,
        // total: 0,
      },
      extraForm: {
        realityBiddingTime: 0, // 实际开标时间
        nonstandardFee: '', // 非标准费用支出说明
        nonstandardPerson: '', // 非标准人员支出说明
        otherRemark: '', // 其他说明
        purchaseSuccess: '', // 采购失败
        failTime: '', // 失败时间
      },
      file: {
        fileId: '',
        fileName: ''
      },
      newUpload: {
        name: ''
      },
      printTitle: '',
      expertFeePrintVisible: false
    }
  },
  computed: {
    // 流程单号
    wiid() {
      /* if (this.flowHistoryData.length === 0) {
        return '未发起'
      }
      return this.flowHistoryData[0].SheetId */
    },
    user() {
      return this.$store.state.session.user
    },
    applyDisabled() {
      const { flowLog = {} } = this.projectData
      if (!flowLog.reviewStatus) return true
      if (flowLog.reviewStatus === '未发起' || (flowLog.reviewStatus.indexOf('提单') !== -1 && flowLog.reviewPerson === this.user.name)) {
        return false
      }
      return true
    },
    realityYDisabled() {
      const { flowLog = {} } = this.projectData
      if (!flowLog.reviewStatus) return true
      if (flowLog.reviewStatus.indexOf('借支转回收') !== -1 && flowLog.reviewPerson === this.user.name) {
        return false
      }
      return true
    },
    realityNDisabled() {
      const { flowLog = {} } = this.projectData
      if (!flowLog.reviewStatus) return true
      if (flowLog.reviewStatus.indexOf('借支转回收') !== -1 && flowLog.reviewPerson === this.user.name) {
        return false
      }
      return true
    },
    extraDisabled() {
      const { flowLog = {} } = this.projectData
      if (!flowLog.reviewStatus) return true
      if (flowLog.reviewStatus.indexOf('借支转回收') !== -1 && flowLog.reviewPerson === this.user.name) {
        return false
      }
      return true
    },
    applyLocalExpertTotal() {
      const { localExpert, localExpertFee } = this.applyExpertForm
      // this.applyExpertForm.localExpertTotal = localExpert * localExpertFee
      return localExpert * localExpertFee
    },
    applyOtherExpertTotal() {
      const { otherExpert, otherExpertFee } = this.applyExpertForm
      // this.applyExpertForm.otherExpertTotal = otherExpert * otherExpertFee
      return otherExpert * otherExpertFee
    },
    applySuperviseTotal() {
      const { supervise, superviseFee } = this.applyExpertForm
      // this.applyExpertForm.superviseTotal = supervise * superviseFee
      return supervise * superviseFee
    },
    applyBuyerTotal() {
      const { buyer, buyerFee } = this.applyExpertForm
      // this.applyExpertForm.buyerTotal = buyer * buyerFee
      return buyer * buyerFee
    },
    applyTrafficTotal() {
      const { traffic, trafficFee } = this.applyExpertForm
      // this.applyExpertForm.trafficTotal = traffic * trafficFee
      return traffic * trafficFee
    },
    applyTotal() {
      const { applyLocalExpertTotal, applyOtherExpertTotal, applySuperviseTotal, applyBuyerTotal, applyTrafficTotal } = this
      // this.applyExpertForm.total = applyLocalExpertTotal + applyOtherExpertTotal + applySuperviseTotal + applyBuyerTotal + applyTrafficTotal + this.applyExpertForm.otherFee
      return add(applyLocalExpertTotal, applyOtherExpertTotal, applySuperviseTotal, applyBuyerTotal, applyTrafficTotal, parseInt(this.applyExpertForm.otherFee))
    },
    applyCostRate() {
      // this.applyExpertForm.costRate = ((this.applyTotal / this.projectData.servicePredict)*100).toFixed(2)
      return ((this.applyTotal / this.projectData.servicePredict)*100).toFixed(2)
    },
    realityYLocalExpertTotal() {
      const { localExpert, localExpertFee } = this.realityExpertFormY
      // this.realityExpertFormY.localExpertTotal = localExpert * localExpertFee
      return localExpert * localExpertFee
    },
    realityYOtherExpertTotal() {
      const { otherExpert, otherExpertFee } = this.realityExpertFormY
      // this.realityExpertFormY.otherExpertTotal = otherExpert * otherExpertFee
      return otherExpert * otherExpertFee
    },
    realityYSuperviseTotal() {
      const { supervise, superviseFee } = this.realityExpertFormY
      // this.realityExpertFormY.superviseTotal = supervise * superviseFee
      return supervise * superviseFee
    },
    realityYBuyerTotal() {
      const { buyer, buyerFee } = this.realityExpertFormY
      // this.realityExpertFormY.buyerTotal = buyer * buyerFee
      return buyer * buyerFee
    },
    realityYTrafficTotal() {
      const { traffic, trafficFee } = this.realityExpertFormY
      // this.realityExpertFormY.trafficTotal = traffic * trafficFee
      return traffic * trafficFee
    },
    realityYTotal() {
      const { realityYLocalExpertTotal, realityYOtherExpertTotal, realityYSuperviseTotal, realityYBuyerTotal, realityYTrafficTotal } = this
      // this.realityExpertFormY.total = realityYLocalExpertTotal + realityYOtherExpertTotal + realityYSuperviseTotal + realityYBuyerTotal + realityYTrafficTotal + this.realityExpertFormY.otherFee
      // return realityYLocalExpertTotal + realityYOtherExpertTotal + realityYSuperviseTotal + realityYBuyerTotal + realityYTrafficTotal + parseInt(this.realityExpertFormY.otherFee)
      return add(realityYLocalExpertTotal, realityYOtherExpertTotal, realityYSuperviseTotal, realityYBuyerTotal, realityYTrafficTotal, parseInt(this.realityExpertFormY.otherFee))
    },
    realityNLocalExpertTotal() {
      const { localExpert, localExpertFee } = this.realityExpertFormN
      // this.realityExpertFormN.localExpertTotal = localExpert * localExpertFee
      return localExpert * localExpertFee
    },
    realityNOtherExpertTotal() {
      const { otherExpert, otherExpertFee } = this.realityExpertFormN
      // this.realityExpertFormN.otherExpertTotal = otherExpert * otherExpertFee
      return otherExpert * otherExpertFee
    },
    realityNSuperviseTotal() {
      const { supervise, superviseFee } = this.realityExpertFormN
      // this.realityExpertFormN.superviseTotal = supervise * superviseFee
      return supervise * superviseFee
    },
    realityNBuyerTotal() {
      const { buyer, buyerFee } = this.realityExpertFormN
      // this.realityExpertFormN.buyerTotal = buyer * buyerFee
      return buyer * buyerFee
    },
    realityNTrafficTotal() {
      const { traffic, trafficFee } = this.realityExpertFormN
      // this.realityExpertFormN.trafficTotal = traffic * trafficFee
      return traffic * trafficFee
    },
    realityNTotal() {
      const { realityNLocalExpertTotal, realityNOtherExpertTotal, realityNSuperviseTotal, realityNBuyerTotal, realityNTrafficTotal } = this
      // this.realityExpertFormN.total = realityNLocalExpertTotal + realityNOtherExpertTotal + realityNSuperviseTotal + realityNBuyerTotal + realityNTrafficTotal + this.realityExpertFormN.otherFee
      return add(realityNLocalExpertTotal, realityNOtherExpertTotal, realityNSuperviseTotal, realityNBuyerTotal, realityNTrafficTotal, parseInt(this.realityExpertFormN.otherFee))
    },
    realityRate() {
      if (!this.projectData.receivables) {
        return ''
      }
      const rate = ((this.realityYTotal + this.realityNTotal)/this.projectData.receivables*100).toFixed(2)
      if (isNaN(rate)) {
        return ''
      }
      return rate
    },
    reimburseYRate() {
      const rate = (this.realityYTotal/(this.realityYTotal + this.realityNTotal)*100).toFixed(2)
      if (isNaN(rate)) {
        return ''
      }
      return rate
    },
    reimburseNRate() {
      const rate = (this.realityNTotal/(this.realityYTotal + this.realityNTotal)*100).toFixed(2)
      if (isNaN(rate)) {
        return ''
      }
      return rate
    },
    realityFeeBack() {
      return subduction('reduce',this.applyTotal, this.realityYTotal)
    },
    bidTime() {
      if (!this.projectData.clMeetingRoom) {
        return ''
      }
      let bidTime = '评标时间'
      let { endTime = '', beginTime = '' } = this.projectData.clMeetingRoom
      if (!beginTime) {
        bidTime = '无设置开始时间'
      }
      if (!endTime) {
        bidTime = '无设置结束时间'
      }
      if (beginTime && endTime) {
        let time = new Date(endTime).getTime() - new Date(beginTime).getTime()
        bidTime = (time / 1000 / 60 / 60) + '小时'
      }
      return bidTime
    }
  },
  methods: {
    print() {
      window.print()
    },
    printView() {
      this.printTitle = `${this.projectData.projectShort}-借支回收证明`
      document.getElementById('expert-print').style.display = 'block'
      this.printPartial(document.getElementById('expert-print'), { title: this.printTitle}, '#expert-print')
      return
      if (this.flowHistoryData.length === 0) {
        this.$Message.info('未发起审批流程')
        return
      }
      this.printPage = true
      this.expertFeePrintVisible = true
      this.printTitle = `${this.projectData.projectShort}-借支回收证明`
    },
    insertData(projectData) {
      if (projectData.flowLog.content) {
        const x2Json = new x2js()
        const xmlJSON = x2Json.xml2js(projectData.flowLog.content)
        this.setForm(this.applyExpertForm, xmlJSON.root.applyExpertForm)
        this.setForm(this.realityExpertFormY, xmlJSON.root.realityExpertFormY)
        this.setForm(this.realityExpertFormN, xmlJSON.root.realityExpertFormN)
        this.setForm(this.extraForm, xmlJSON.root.extraForm)
        this.file = {
          fileId: projectData.flowLog.fileId,
          fileName: projectData.flowLog.fileName,
        }
      } else {
        this.clearData()
      }
    },
    clearData() {
      this.applyExpertForm = {
        localExpert: 0,
        localExpertFee: 0,
        // localExpertTotal: 0,
        otherExpert: 0,
        otherExpertFee: 0,
        // otherExpertTotal: 0,
        supervise: 0,
        superviseFee: 0,
        // superviseTotal: 0,
        buyer: 0,
        buyerFee: 0,
        // buyerTotal: 0,
        traffic: 0,
        trafficFee: 0,
        // trafficTotal: 0,
        otherFee: 0,
        remark: '',
        // total: 0,
        // costRate: 0
      }
      this.realityExpertFormY = {
        localExpert: 0,
        localExpertFee: 0,
        // localExpertTotal: 0,
        otherExpert: 0,
        otherExpertFee: 0,
        // otherExpertTotal: 0,
        supervise: 0,
        superviseFee: 0,
        // superviseTotal: 0,
        buyer: 0,
        buyerFee: 0,
        // buyerTotal: 0,
        traffic: 0,
        trafficFee: 0,
        // trafficTotal: 0,
        otherFee: 0,
        // total: 0,
      }
      this.realityExpertFormN = {
        localExpert: 0,
        localExpertFee: 0,
        // localExpertTotal: 0,
        otherExpert: 0,
        otherExpertFee: 0,
        // otherExpertTotal: 0,
        supervise: 0,
        superviseFee: 0,
        // superviseTotal: 0,
        buyer: 0,
        buyerFee: 0,
        // buyerTotal: 0,
        traffic: 0,
        trafficFee: 0,
        // trafficTotal: 0,
        otherFee: 0,
        // total: 0,
      }
      this.extraForm = {
        realityBiddingTime: 0,
        nonstandardFee: '',
        nonstandardPerson: '',
        otherRemark: '',
        purchaseSuccess: '',
        failTime: '',
      },
      this.file = {
        fileId: '',
        fileName: ''
      }
    },
    setForm(oldObj = {}, newObj = {}) {
      const oldObjKeys = Object.keys(oldObj)
      oldObjKeys.forEach(key => {
        this.$set(oldObj, key, newObj[key])
      })
    },
    getResult() {
      return {
        applyExpertForm: this.applyExpertForm,
        realityExpertFormY: this.realityExpertFormY,
        realityExpertFormN: this.realityExpertFormN,
        extraForm: this.extraForm
      }
    },
    getApplyTotal() {
      return this.applyTotal
    },
    handleBeforeUpload(file) {
      let format = ['jpg', 'jpeg', 'png', 'pdf']
      let type = file.name.split('.')
      type = type[type.length - 1]
      if (format.indexOf(type) === -1) {
        this.$Message.info('不支持的文件类型')
        return false
      }
      this.newUpload = file
      this.$set(this.file, 'fileName', file.name)
      this.$set(this.file, 'fileId', '')
      return false
    },
    async uploadFile(objectid) {
      if (this.newUpload.name !== '') {
        const suffix = fileUtil.get_suffix(this.newUpload.name)
        this.uploadFileInit.extradata.key = this.uploadFileInit.extradata.key + fileUtil.random_string(10) + suffix
        this.uploadFileInit.extradata['x:displayname'] = this.newUpload.name
        this.uploadFileInit.extradata['x:objectid'] = objectid
        this.uploadFileInit.extradata['x:objectidtype'] = 'expertFeeBack'
        this.$Spin.show()
        let uploadData = new FormData()
        for (let key in this.uploadFileInit.extradata) {
          uploadData.append(key, this.uploadFileInit.extradata[key])
        }
        uploadData.append('file', this.newUpload)
        let rep = await axios.post(this.uploadFileInit.action, uploadData)
        this.$Spin.hide()
        // 清空已上存数据
        this.newUpload = {
          name: ''
        }
        this.file = {
          fileName: rep.data.result.displayName,
          fileId: rep.data.result.id
        }
        return this.file
      }
      return false
    },
    async downloadFile() {
      if (!this.file.fileId) {
        this.$Message.info('未有保存上传资料')
        return
      }
      try {
        this.$Spin.show()
        let imgFormat = ['jpg', 'jpeg', 'png']
        let pdfFormat = ['pdf']
        let type = this.file.fileName.split('.')
        type = type[type.length - 1]
        let fileUrl = await fileUtil.downLoadBlob(this.file.fileId)
        this.$Spin.hide()
        if (imgFormat.indexOf(type) !== -1) {
          this.$showImage(fileUrl)
        }
        if (pdfFormat.indexOf(type) !== -1) {
          window.open('pdf/web/viewer.html?file=' + fileUrl)
        }
      } catch(err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('获取图片失败')
      }
    },
    printPartial(dom, { title= document.title,}= {}, specialStyle = '') {
      if (!dom) return;
      let copyDom = document.createElement('span');
      const styleDom = document.querySelectorAll('style');
      const titleDom = document.createElement('title');
      titleDom.innerText = title;

      copyDom.appendChild(titleDom);
      Array.from(styleDom).forEach(item=> {
        if (item.childNodes[0].nodeValue.indexOf(specialStyle) !== -1) {
          copyDom.appendChild(item.cloneNode(true));
        }
      });
      const childNodes = dom.childNodes;
      copyDom.appendChild(dom.cloneNode(true));

      const htmlTemp = copyDom.innerHTML;
      copyDom = null;

      const iframeDom = document.createElement('iframe');
      const attrObj = {
        height: 0,
        width: 0,
        border: 0,
        wmode: 'Opaque'
      };
      const styleObj = {
        position: 'absolute',
        top: '-999px',
        left: '-999px',
      };
      Object.entries(attrObj).forEach(([key, value])=> iframeDom.setAttribute(key, value));
      Object.entries(styleObj).forEach(([key, value])=> iframeDom.style[key] = value);
      document.body.insertBefore(iframeDom, document.body.children[0]);
      const iframeWin = iframeDom.contentWindow;
      const iframeDocs = iframeWin.document;
      iframeDocs.write(`<!doctype html>`);
      iframeDocs.write(htmlTemp);
      iframeWin.focus();
      iframeWin.print();
      document.body.removeChild(iframeDom);
      dom.style.display = 'none'
    }
  },
  watch: {
    projectData(val) {
      if (val) {
        this.currentTab = 'apply'
        this.insertData(val)
        this.newUpload = {
          name: ''
        }
      }
    }
  },
  filters: {
    filterHistoryStatus(val) {
      let result = '未知状态'
      switch (val) {
        case 'StartWorkflow':
          result = '发起'
          break
        case 'Approval':
          result = '通过'
          break
        case 'Reject':
          result = '驳回'
          break
        case '':
          result = '待办'
          break
      }
      return result
    },
    filterFlowTime(val) {
      if (!val) {
        return ''
      }
      let time = parseInt(val.slice(6, 19))
      time = formatDate(time).split(' ')[0]
      return time
    }
  }
}
</script>

<style lang="less" scoped>
.expert-form-table {
  td,th {
    border: 1px solid #ddd;
  }
}
#expert-print {
  display: none;
  .split-page {
    margin-top: 36px;
    page-break-after:always;
    page-break-before:auto;
    .expert-form-table {
      td,th {
        border: 1px solid #ddd;
      }
    }
    .extra-table-style {
      th, tr td {
        padding: 5px;
      }
    }
  }
  .base-info {
    border: 1px solid #ddd;
    padding: 5px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: 14px;
    div {
      padding: 5px;
      margin-right: 5px;
      min-width: 200px;
    }
  }
}
.base-info {
  border: 1px solid #ddd;
  padding: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 14px;
  div {
    padding: 5px;
    margin-right: 5px;
    min-width: 200px;
  }
}
.expert-form {
  /deep/ .ivu-form-item {
    margin-bottom: 0;
    padding: 5px 0;
  }
  /deep/ .ivu-form-item-label {
    line-height: 15px;
  }
  /deep/ .ivu-input[disabled], fieldset[disabled] .ivu-input {
    color: #495060;
  }
}
.extra-table-style {
  th, tr td {
    padding: 5px;
  }
}
/deep/.print-modal {
  .ivu-modal {
    top: 30px;
  }
  .ivu-modal-close {
    display: none;
  }
}
@media print {
  .print-btn {
    display: none;
  }
}
</style>
